import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import SimpleButton from '@components/SimpleButton';

import Shell from '@shared/containers/Shell';
import FixedHeader from '@components/FixedHeader';
import ShellFooter from '@components/ShellFooter';
import Card from '@components/Card';

import OptionRowCheckbox from '../OptionRowCheckbox';
import Container from './components/Container';

class OptionList extends PureComponent {
  constructor(props) {
    super(props);

    const { initialValue, optionGroup } = props;

    const selected = initialValue?.options
      ? initialValue.options.map(x => x.id)
      : [];
    const selectionIsCompleted = this.selectionIsCompleted(
      optionGroup,
      selected,
    );

    this.state = { selected, selectionIsCompleted };
  }

  selectionIsCompleted = (optionGroup, selected) =>
    !optionGroup.minQuantity || optionGroup.minQuantity <= selected.length;

  onSelect = id => () => {
    const { optionGroup } = this.props;

    this.setState(state => {
      let selected = [...state.selected];

      if (selected.some(x => x === id))
        selected = selected.filter(x => x !== id);
      else if (
        !optionGroup.maxQuantity ||
        optionGroup.maxQuantity > selected.length
      ) {
        selected.push(id);
      }

      const selectionIsCompleted = this.selectionIsCompleted(
        optionGroup,
        selected,
      );

      return { selected, selectionIsCompleted };
    });
  };

  onConfirm = () => {
    const { optionGroup, onConfirm } = this.props;
    const { selected } = this.state;

    onConfirm({
      id: optionGroup.id,
      options: selected.map(x => ({ id: x })),
    });
  };

  render() {
    const { optionGroup, onClose, Footer = SimpleButton } = this.props;
    const { options } = optionGroup;
    const { selected, selectionIsCompleted } = this.state;

    return (
      <Shell
        isModal
        header={<FixedHeader label={optionGroup.name} onClose={onClose} />}
        footer={
          <ShellFooter>
            <Footer
              elementId="product__option__list"
              label="Aceptar"
              color="primary"
              onClick={this.onConfirm}
              disabled={!selectionIsCompleted}
              block
            />
          </ShellFooter>
        }
      >
        <Container>
          <Card direction="column">
            {options.map(x => (
              <OptionRowCheckbox
                key={x.id}
                name={x.name}
                isSelected={selected.includes(x.id)}
                onSelect={this.onSelect(x.id)}
                amount={x.amount}
                modifiesPrice={x.modifiesPrice}
              />
            ))}
          </Card>
        </Container>
      </Shell>
    );
  }
}

OptionList.propTypes = {
  optionGroup: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    options: PropTypes.array,
    maxQuantity: PropTypes.number,
  }).isRequired,
  initialValue: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,

  // Joker
  Footer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default OptionList;
